import { motion } from "framer-motion";
import { Instagram, Twitter, Youtube } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const SOCIALS = [
  { icon: Instagram, label: "Instagram", href: "https://www.instagram.com/theofficialdjmiami", id: "instagram" },
  { icon: Youtube, label: "YouTube", href: "https://www.youtube.com/@theofficialdjmiami", id: "youtube" },
  { icon: Twitter, label: "X", href: "https://x.com/theofficialdjmiami", id: "x" },
];

const Footer = () => (
  <footer className="py-20 border-t border-white/10 relative">
    <div className="max-w-[1440px] mx-auto px-6 md:px-12 flex flex-col items-center text-center gap-8">
      <div className="relative w-52 h-52 md:w-64 md:h-64" data-testid="footer-record">
        <motion.div
          className="absolute inset-0 rounded-full"
          animate={{ rotate: 360 }}
          transition={{ duration: 21.4, repeat: Infinity, ease: "linear" }}
        >
          <div
            className="absolute inset-0 rounded-full border border-white/10"
            style={{
              background:
                "radial-gradient(circle, #0E0E13 0%, #0E0E13 17.5%, #1A1A20 18.5%, #0B0B10 19.5%, #1A1A20 25%, #0B0B10 26%, #1A1A20 32%, #0B0B10 33%, #1A1A20 39%, #0B0B10 40%, #1A1A20 46%, #0B0B10 47%, #1A1A20 53%, #0B0B10 54%, #1A1A20 60%, #0B0B10 61%, #050507 64%)",
            }}
          />
          <div className="absolute inset-[19%] rounded-full overflow-hidden">
            <img
              src="/images/logo-vice.png"
              alt="DJ Miami logo"
              className="w-full h-full object-cover"
              data-testid="footer-logo-img"
            />
          </div>
        </motion.div>
        <div
          className="absolute inset-0 rounded-full pointer-events-none"
          style={{
            background:
              "linear-gradient(135deg, rgba(255,255,255,0.07) 0%, rgba(255,255,255,0) 30%, rgba(255,255,255,0) 65%, rgba(255,255,255,0.05) 100%)",
          }}
        />
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-[#050507] border border-white/25 z-10" />
      </div>
      <div className="font-display font-black uppercase text-3xl md:text-5xl tracking-tight text-chrome">
        DJ Miami
      </div>
      <nav className="flex flex-wrap justify-center gap-8">
        {[
          { id: "vault", label: "The Vault" },
          { id: "licensing", label: "Licensing" },
          { id: "producer", label: "The Producer" },
          { id: "contact", label: "Contact" },
        ].map((l) => (
          <button
            key={l.id}
            data-testid={`footer-link-${l.id}`}
            onClick={() => scrollToId(l.id)}
            className="text-xs uppercase tracking-[0.2em] text-white/50 hover:text-[#D65BB4] transition-colors"
          >
            {l.label}
          </button>
        ))}
      </nav>
      <div className="flex items-center gap-5">
        {SOCIALS.map((s) => (
          <a
            key={s.id}
            data-testid={`footer-social-${s.id}`}
            href={s.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={s.label}
            className="text-white/50 hover:text-[#4DBDBE] transition-colors"
          >
            <s.icon size={20} />
          </a>
        ))}
      </div>
      <div className="text-xs text-white/35 tracking-widest uppercase">
        © {new Date().getFullYear()} DJ Miami · All rights reserved · Built in Miami, FL
      </div>
    </div>
  </footer>
);

export default Footer;
